import { AnchorProvider, Program } from "@coral-xyz/anchor";
import { useAnchorWallet, useConnection } from "@solana/wallet-adapter-react";
import idl from "../idl/fartlab.json";
import { Fartlab } from "../idl/types/fartlab";
// import { setProvider } from "@solana/wallet-adapter-base";
// import { IDL, FartLab } from "../../idl";
import { PublicKey } from "@solana/web3.js";
import { PROGRAM_ID } from "../utils/constants";

// // 🛠️ Define the program ID
// const programId = new PublicKey(PROGRAM_ID || idl.address); // Uses constant or IDL address

// // 🛠️ Create a connection to the Solana network
// const LOCALHOST_RPC = "http://127.0.0.1:8899"; // Change this if needed
// const connection = new Connection(LOCALHOST_RPC, "confirmed");
// const readOnlyWallet = {
//   publicKey: new PublicKey("11111111111111111111111111111111"),
//   signTransaction: async () => {
//     throw new Error("Read-only wallet can't sign.");
//   },
//   signAllTransactions: async () => {
//     throw new Error("Read-only wallet can't sign.");
//   },
// };


// // 🛠️ Create and export a function to initialize the provider and program
// export const getProgram = (walletPublicKey: any) => {
//   // const wallet = getWallet();
//   // if (!walletPublicKey) throw new Error("❌ Phantom Wallet not found! Install it.");

//   // ✅ Create the Anchor Provider
//   const provider = new AnchorProvider(
//     connection,
//     walletPublicKey ? walletPublicKey : readOnlyWallet,
//     AnchorProvider.defaultOptions()
//   );
//   setProvider(provider); // ✅ Set the provider globally for Anchor

//   // ✅ Initialize the program interface
//   const program = new Program<Fartlab>(idl as Fartlab, provider);
//   const wallet = provider.wallet;
//   const isReadOnly = walletPublicKey ? false : true;
//   return { program, provider, connection, walletKp: wallet, programId, isReadOnly };
// };

export const useFartlabProgram = () => {
  const wallet = useAnchorWallet();
  const { connection } = useConnection();
  const programId = new PublicKey(PROGRAM_ID || idl.address);

  const provider = new AnchorProvider(connection, wallet, {
    commitment: "confirmed",
  });

  const isReadOnly = wallet ? false : true;
  const program = new Program<Fartlab>(idl as Fartlab, provider);
  return { program, provider, connection, wallet, programId, isReadOnly };
};